import React from "react";
import EditButton from "../EditButton";

/**
 * Property bar: Edit button (in edit mode) and/or labels ("You added/edited", etc.).
 * Renders next to the Living SqFt cell when the row is in edit mode or added/edited/deleting.
 */
function PropertyBar({
  editMode = false,
  onEditPropertyClick,
  property,
  index,
  isDeleted,
  isDeleting,
  isAdding,
  isManuallyAdded,
  isAdded,
  isEdited,
}) {
  const labels = [];
  if (isDeleted) labels.push({ key: "deleted", text: "DELETED", className: "deleted-property-label" });
  else if (isDeleting) labels.push({ key: "deleting", text: "DELETING This Property", className: "deleting-property-label" });
  else if (isAdding) labels.push({ key: "adding", text: "ADDING", className: "adding-property-label" });
  else if (isManuallyAdded || isAdded) labels.push({ key: "added", text: "You ADDED This Property", className: "added-property-label" });
  else if (isEdited) labels.push({ key: "edited", text: "You EDITED This Property", className: "edited-property-label" });

  // Apart from edit mode, property bar labels are always shown when present; in edit mode only the Edit button shows
  const showLabels = labels.length > 0 && !editMode;
  const show = editMode || showLabels;
  if (!show) return null;

  return (
    <div className={`property-bar-label-wrapper ${editMode ? "property-bar-has-edit" : ""}`}>
      {editMode && (
        <EditButton
          label={
            property?._isManuallyAdded || property?._isAdded
              ? "You Added This Property"
              : property?._isEdited
              ? "You Edited This Property"
              : "EDIT"
          }
          onClick={() => onEditPropertyClick?.(property, index)}
        />
      )}
      {showLabels && (
        labels.map(({ key, text, className }) => (
          <div key={key} className={`property-bar-label ${className}`}>
            {text}
          </div>
        ))
      )}
    </div>
  );
}

export default PropertyBar;
